import { html, type Html, Page, rune } from 'rune-ts';
import klass from './CreatorViewDetail.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { main_detail } from '../../../../../modules/MShop/App/Today/S/Tmpl/main_detail';
import { CreatorViewListItem } from '../../components/cells/CreatorViewListItem/CreatorViewListItem';
import { MShopUtilF } from '../../../../../modules/MShop/Util/F/Function/module/MShopUtilF';
import { Header } from '../../components/cells/Header/Global/Header.ts';
import { $delegate, $qs } from 'fxdom/es';
import { listenDocumentEvent } from '../../../shared/util/event';
import { go } from 'fxjs/es';
import Swiper from 'swiper';
import UAParser from 'ua-parser-js';
import {
  CreatorViewDetail,
  CreatorViewListItemData,
  NearCreatorViewItem,
} from '../../../features/CreatorView/type';
import { makeMainUrl } from '../../../shared/util/url';
import { hydrateFeed } from '../CurationDetail/util';
import { FeedProductListPreviewView } from '../../../../../modules/Plus/Event/S/Tmpl/form';
import { BaseLayoutOptions } from '../../../features/Core/service';
import header_klass from '../../components/cells/Header/Global/Header.module.scss';
import sanitizer from 'sanitizer';

export type CreatorViewDetailPageData = {
  related_creator_views: CreatorViewListItemData[];
  creator_view: CreatorViewDetail;
  next_creator_view: NearCreatorViewItem | undefined;
  prev_creator_view: NearCreatorViewItem | undefined;
  layout_options: BaseLayoutOptions;
};

export class CreatorViewDetailPage extends Page<CreatorViewDetailPageData> {
  override onMount() {
    super.onMount();
    const {
      layout_options: { is_mobile },
    } = this.data;
    const header_el = document.querySelector('.Header') as HTMLElement;
    const header_view = rune.getView(header_el, Header) as Header;

    // 헤드룸 offset 커스텀
    const padding_top_of_today_body = parseInt(window.getComputedStyle($qs('.today-body'))?.marginTop || '0');

    const header_element = header_view.element().querySelector(`.${header_klass.header}`) as HTMLDivElement;
    Header.initHeadroom(header_element, {
      ...header_view.state.headroom,
      use: true,
      offset: {
        up: padding_top_of_today_body,
        down: padding_top_of_today_body,
      },
    });

    // 아래쪽 관련 아이템 스와이퍼 적용
    if (is_mobile) {
      new Swiper('.today-relates__items', {
        loop: false,
        slidesPerView: 'auto',
        allowTouchMove: true,
      });
    }

    const left_sidebar_el = $qs('.today-body__left_sidebar') as HTMLDivElement;

    listenDocumentEvent('header_pinned', () => {
      left_sidebar_el.classList.remove('unpinned');
    });
    listenDocumentEvent('header_unpinned', () => {
      left_sidebar_el.classList.add('unpinned');
    });
    listenDocumentEvent('header_top', () => {
      left_sidebar_el.classList.add('top');
    });
    listenDocumentEvent('header_nottop', () => {
      left_sidebar_el.classList.remove('top');
    });

    go(
      this.element(),
      $delegate('click', '.share-btn', (e) => {
        const is_app = MShopUtilF.isApp();
        const title = e.currentTarget.dataset.title;
        const ua = new UAParser();
        const app_version = (/MarppleShopApp@(\w+.\w+.\w+)/gm.exec(ua.getUA()) || [])[1];

        if (is_app && app_version && app_version >= '1.1.0') {
          return MShopUtilF.postMessage({
            share: {
              title: `${T('마플샵')} - ${title}`,
              url: location.href,
            },
          });
        }

        try {
          navigator.clipboard
            .writeText(location.href)
            .then(() => {
              MShopUtilF.popToastMsg(T('s_about::url_copied2'), 'info');
            })
            .catch(() => {
              MShopUtilF.popToastMsg(T('s_about::url_failed'), 'info');
            });
        } catch (e) {
          MShopUtilF.clipboard(location.href);
          MShopUtilF.popToastMsg(T('s_about::url_copied2'), 'info');
        }
      }),
      $delegate('click', 'a', (e) => {
        if (!e.currentTarget.href.includes('/@/todays/') || !MShopUtilF.isApp()) return;
        e.originalEvent.preventDefault();
        location.replace(e.currentTarget.href);
      }),
    );

    hydrateFeed(this.element());
  }

  protected override template(): Html {
    const { related_creator_views, creator_view, next_creator_view, prev_creator_view, layout_options } =
      this.data;

    const { is_mobile } = layout_options;

    const related_todays_html = `
        ${related_creator_views
          .slice(0, 4)
          .map((creator_view) =>
            new CreatorViewListItem(creator_view, {
              is_mobile,
              klass: `${klass.related_item} swiper-slide`,
              thumbnail_type: 'long',
            }).toHtml(),
          )
          .join('')}
    `;

    const products_html = new FeedProductListPreviewView({
      is_mobile,
      products: creator_view.products,
      is_popupstore: false,
      klass: 'today-body__products',
    }).toHtmlSSR();

    return html`
      <div class="${klass.page}">
        ${new LayoutView(
          {
            body: html`${html.preventEscape(
              main_detail({
                is_mobile,
                related_section_title: ET('mps2::section_title::sub_title::latest_creator_view'),
                products_html,
                related_todays_html,
                next_today: next_creator_view,
                prev_today: prev_creator_view,
                today: creator_view,
                is_sharable: true,
                feed_category_id: undefined,
                show_related_see_more: related_creator_views.length > 4,
                steps: [
                  {
                    href: makeMainUrl('/@/creator_views'),
                    label: ET('mps2::section_title::section_tabs::creator_view'),
                  },
                  {
                    href: makeMainUrl(`/@/creator_views/${creator_view.id}`),
                    label: ET('mps2::breadcrumbs::detail'),
                  },
                ],
              }),
            )}`,
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            full_width: is_mobile,
            floating_box: {
              share: is_mobile
                ? {
                    title: sanitizer.unescapeEntities(creator_view.title),
                    description: ET('mps2::share::creator_view_description', {
                      creator_name: creator_view.creator_name,
                    }),
                  }
                : undefined,
            },
            ...layout_options,
          },
        )}
      </div>
    `;
  }
}
